import { render, staticRenderFns } from "./Cupom.vue?vue&type=template&id=8d2bcc22"
import script from "./Cupom.vue?vue&type=script&lang=js"
export * from "./Cupom.vue?vue&type=script&lang=js"
import style0 from "./Cupom.vue?vue&type=style&index=0&id=8d2bcc22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports